export default {
  lifestyle: {
    // dietaryRestrictionDetails: {
    //   unDocumented: {
    //     issues: [
    //       { id: 'I-SH-LIFE-1000',
    //        domain: 'DPFC'
    //       }
    //     ],
    //     isDependent: true,
    //     dependency: {
    //       field: 'dietaryRestriction',
    //       triggerValue: 'yes'
    //     }
    //   }
    // },
    // dietaryPreferenceDetails: {
    //   unDocumented: {
    //     issues: [
    //       { id: 'I-SH-LIFE-1100',
    //        domain: 'DPFC'
    //       }
    //     ],
    //     isDependent: true,
    //     dependency: {
    //       field: 'dietaryPreference',
    //       triggerValue: 'yes'
    //     }
    //   }
    // },
    culturalNeeds: {
      issues: [
        {
          id: 'I-SH-LIFE-1200',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'yes'
    },
    // culturalNeedsDetails: {
    //   unDocumented: {
    //     issues: [
    //       { id: 'I-SH-LIFE-1300',
    //        domain: 'DPFC'
    //       }
    //     ],
    //     isDependent: true,
    //     dependency: {
    //       field: 'culturalNeeds',
    //       triggerValue: 'yes'
    //     }
    //   }
    // },
    religiousActivities: {
      issues: [
        {
          id: 'I-SH-LIFE-1500',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'yes'
    },
    spiritualDistress: {
      issues: [
        {
          id: 'I-SH-LIFE-1600',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'yes'
    },
    spiritualDistressDetails: {
      unDocumented: {
        issues: [
          {
            id: 'I-SH-LIFE-1700',
            domain: 'DPFC'
          }
        ],
        isDependent: true,
        dependency: {
          field: 'spiritualDistress',
          triggerValue: 'yes'
        }
      }
    }
    //   militaryService: {
    //     unDocumented: {
    //       issues: [
    //         { id: 'I-SH-LIFE-1800',
    //          domain: 'DPFC'
    //         }
    //       ]
    //     }
    //   },
    //   militaryBenefits: {
    //     unDocumented: {
    //       issues: [
    //         { id: 'I-SH-LIFE-1900',
    //          domain: 'DPFC'
    //         }
    //       ],
    //       isDependent: true,
    //       dependency: {
    //         field: 'militaryService',
    //         triggerValue: 'yes'
    //       }
    //     }
    //   }
  },
  resources: {
    safety: {
      issues: [
        {
          id: 'I-SH-LIFE-2000',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'no'
    },
    financialNeeds: {
      issues: [
        {
          id: 'I-SH-RES-1100',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'no'
    },
    financialMedicalCare: {
      issues: [
        {
          id: 'I-SH-RES-1200',
          domain: 'DBDC'
        }
      ],
      triggerValue: 'no'
    },
    medicalCareCost: {
      issues: [
        {
          id: 'I-SH-RES-1300',
          domain: 'DBDC'
        }
      ],
      triggerValue: 'no'
    },
    financialStress: {
      issues: [
        {
          id: 'I-SH-RES-1400',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'yes'
    },
    transportationCare: {
      issues: [
        {
          id: 'I-SH-RES-1500',
          domain: 'DPAE'
        }
      ],
      triggerValue: 'yes'
    },
    transportationActivities: {
      issues: [
        {
          id: 'I-SH-RES-1600',
          domain: 'DPFC'
        }
      ],
      triggerValue: 'yes'
    },
    communityResource: {
      issues: [
        {
          id: 'I-SH-RES-1700',
          domain: 'DPFC',
          isDynamic: true,
          dynamicParameters: { need: 'communityResourceDetails' }
        }
      ],
      triggerValue: 'yes'
    },
    legalMatters: {
      issues: [
        {
          id: 'I-SH-LIFE-2100',
          domain: 'DPFC',
          isDynamic: true,
          dynamicParameters: { reason: 'legalMattersDetails' }
        }
      ],
      triggerValue: 'yes'
    }
  },
  substances: {
    activelyUsing: {
      issues: [
        {
          id: 'I-SH-SUB-1000',
          domain: 'DPMH',
          isDynamic: true,
          dynamicParameters: { substance: 'type' }
        }
      ],
      triggerValue: 'yes'
    },
    desireToQuit: {
      issues: [
        {
          id: 'I-SH-SUB-1100',
          domain: 'DPMH',
          isDynamic: true,
          dynamicParameters: { substance: 'type' }
        }
      ],
      triggerValue: 'yes'
    },
    healthEffects: {
      issues: [
        {
          id: 'I-SH-SUB-1200',
          domain: 'DPMH',
          isDynamic: true,
          dynamicParameters: { substance: 'type' }
        }
      ],
      triggerValue: 'yes'
    }
  }
}
